export default __webpack_public_path__ + "static/media/evaluationHistory.686d0ead.svg";